import androidx.compose.runtime.compositionLocalOf

/**
 * How a foldable is being held, so the game can lay itself out around the hinge. Hinge bounds are
 * in window pixels. Only Android reports anything but [Flat]; everywhere else the layouts are
 * unchanged.
 */
sealed interface FoldPosture {
    /** No fold in play: a regular phone, or a foldable held flat or closed. */
    data object Flat : FoldPosture

    /** Half-open with a horizontal hinge, propped on a table like a tiny laptop. */
    data class Tabletop(val hingeTopPx: Float, val hingeBottomPx: Float) : FoldPosture

    /** Half-open (or split by a physical hinge) with a vertical fold, held like a book. */
    data class Book(val hingeLeftPx: Float, val hingeRightPx: Float) : FoldPosture
}

val LocalFoldPosture = compositionLocalOf<FoldPosture> { FoldPosture.Flat }
